import { render, staticRenderFns } from "./TxRow.vue?vue&type=template&id=63603218"
import script from "./TxRow.vue?vue&type=script&lang=js"
export * from "./TxRow.vue?vue&type=script&lang=js"
import style0 from "./TxRow.vue?vue&type=style&index=0&id=63603218&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports